module.exports = __webpack_public_path__ + "img/collectWhite.bef8b870.svg";